import num from './lib/num';

export default num;
export * from './lib/num';
